import 'reflect-metadata';
import {jsonObject, jsonMember, TypedJSON} from 'typedjson';

import {ConnectionSettings} from '@/model/network/settings/ConnectionSettings';
import {Ip4Settings, Ip6Settings} from '@/model/network/settings/IpSettings';
import {EthernetSettings} from '@/model/network/settings/EthernetSettings';
import {VpnServiceType, VpnSettings} from '@/model/network/settings/VpnSettings';
import {OpenVpnSettings} from '@/model/network/settings/OpenVpnSettings';

@jsonObject({knownTypes: [OpenVpnSettings]})
export class ProfileSettings {

  public static get Serializer(): TypedJSON<ProfileSettings> {
    if (!ProfileSettings.serializer) {
      ProfileSettings.serializer = new TypedJSON(ProfileSettings);
    }

    return ProfileSettings.serializer;
  }

  private static serializer: TypedJSON<ProfileSettings> | undefined;

  @jsonMember({name: 'connection'})
  public Connection!: ConnectionSettings;

  @jsonMember({name: 'ipv4'})
  public IPv4!: Ip4Settings;

  @jsonMember({name: 'ipv6'})
  public IPv6!: Ip6Settings;

  @jsonMember({name: 'ethernet'})
  public Ethernet!: EthernetSettings;

  @jsonMember({name: 'vpn'})
  public Vpn!: VpnSettings;

  constructor(settings?: Partial<ProfileSettings>) {
    if (settings) {
      this.Connection = new ConnectionSettings(settings.Connection);
      this.IPv4 = new Ip4Settings(settings.IPv4);
      this.IPv6 = new Ip6Settings(settings.IPv6);
      this.Ethernet = new EthernetSettings(settings.Ethernet);

      switch (settings.Vpn?.ServiceType) {
        case VpnServiceType.OpenVpn:
          this.Vpn = new OpenVpnSettings(settings.Vpn);
          break;

        default:
          this.Vpn = new VpnSettings(settings.Vpn);
          break;
      }
    }
  }
}
